import { render, staticRenderFns } from "./LeaveApprovalSettings.vue?vue&type=template&id=7a97a69b&scoped=true&"
import script from "./LeaveApprovalSettings.vue?vue&type=script&lang=js&"
export * from "./LeaveApprovalSettings.vue?vue&type=script&lang=js&"
import style0 from "./LeaveApprovalSettings.vue?vue&type=style&index=0&id=7a97a69b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a97a69b",
  null
  
)

export default component.exports